import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasQueryProvider, GasToastProvider, GasConfirmProvider } from '../../shared/kit';
import App from './App';
import type { PlanDetailInitData } from './types';
import './style.css';

const mountEl = document.getElementById('gas-membership-plan-app');
if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    let initData: PlanDetailInitData;
    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as PlanDetailInitData;
    } catch (error) {
        mountEl.textContent = '';
        throw error;
    }

    createRoot(mountEl).render(
        <React.StrictMode>
            <GasQueryProvider>
                <GasToastProvider>
                    <GasConfirmProvider>
                        <App initData={initData} />
                    </GasConfirmProvider>
                </GasToastProvider>
            </GasQueryProvider>
        </React.StrictMode>,
    );
}
